import { OUTBOUND_TYPE } from "@erp/shared/types/outbound-type.types";
import { STOCK_APPROVAL_PHASE } from "@erp/shared/types/stock-approval-phase.types";
export const searchCardInputs = [
    {
        label: "승인",
        key: "approvalPhase",
        type: "auto",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        list: [
            STOCK_APPROVAL_PHASE.미확인,
            STOCK_APPROVAL_PHASE.미승인,
            STOCK_APPROVAL_PHASE.승인,
            STOCK_APPROVAL_PHASE.반려,
        ],
        clearable: true,
    },
    {
        label: "프로젝트",
        key: "projectCode",
        type: "auto",
        list: [],
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "출고방식",
        key: "addData",
        type: "auto",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        list: [OUTBOUND_TYPE.출고, OUTBOUND_TYPE.재고이동],
        clearable: true,
    },
    {
        label: "출하장소",
        key: "outboundPlace",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
    },
    {
        label: "출고목적",
        key: "purpose",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "출고 요청일",
        key: "outboundDate",
        type: "dateRange",
        value: [],
        col: "12",
        sm: "4",
        lg: "3",
    },
];
export const outboundApproveHeaders = [
    { text: "No.", align: "center", value: "id" },
    { text: "승인 단계", align: "center", value: "approvalPhase" },
    { text: "작성일", align: "center", value: "createdTime" },
    { text: "요청자", align: "center", value: "createrName" },
    { text: "확인자", align: "center", value: "checkerName" },
    { text: "승인자", align: "center", value: "approverName" },
    { text: "프로젝트", align: "center", value: "projectCode" },
    { text: "출고요청일", align: "center", value: "outboundDate" },
    { text: "출하장소", align: "center", value: "outboundSpotName" },
    { text: "출고목적", align: "center", value: "purpose" },
    { text: "출고방식", align: "center", value: "addData" },
];
export const outboundProductHeaders = [
    { text: "종류", align: "center", value: "type" },
    { text: "분류", align: "center", value: "classification" },
    { text: "관리코드", align: "center", value: "productCode" },
    { text: "제품명", align: "center", value: "name" },
    { text: "모델명", align: "center", value: "model" },
    { text: "사양", align: "center", value: "spec" },
    { text: "제조사", align: "center", value: "manufacturer" },
    { text: "위치", align: "center", value: "spot" },
    { text: "출고수량", align: "center", value: "num" },
    { text: "현재고", align: "center", value: "productTotalStockNum" },
    { text: "단가", align: "center", value: "unitPrice" },
];
